var React = require('react');

function IconQuestionMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M298.3 373H196.7c-2.2 0-4-1.8-4-4-2-206.6 97.6-308.3 299.1-305 176.1 6.7 267.4 91.4 274.1 254.2 0 63.2-41.6 132.9-124.6 209.3-76.5 69.8-114.6 131.3-114.6 184.4v40.9c0 2.2-1.8 4-4 4H426c-2.2 0-4-1.8-4-4V687c0-59.8 38.2-127.9 114.6-204.3 66.4-66.4 103-121.3 109.6-164.5-6.7-86.4-53.2-134.6-139.6-144.5-138-6.6-206.3 58.4-204.3 195.2.1 2.3-1.7 4.1-4 4.1zm230 482.7v98c0 2.2-1.8 4-4 4h-100c-2.2 0-4-1.8-4-4v-98c0-2.2 1.8-4 4-4h100c2.2 0 4 1.8 4 4z"}));
}

IconQuestionMark.displayName = "IconQuestionMark";

IconQuestionMark.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconQuestionMark;

IconQuestionMark.default = IconQuestionMark;
